import React from "react";
import HomeServiceItem from "../../../../components/HomeServiceItem/HomeServiceItem";
import { useTranslation } from "react-i18next";

const ServiceArea = () => {
  const { t } = useTranslation();

  return (
    <>
      <section className="tp-services-area theme-dark-bg">
        <div className="tp-custom-container" id="services">
          <div className="tp-services-bg grey-bg pt-120 pb-90 z-index">
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div
                    className="tp-section-title-wrapper text-center mb-55 wow fadeInUp"
                    data-wow-delay=".1s"
                  >
                    <h1 className="tp-section-subtitle section__sm__title common-yellow-shape mb-25">
                      {t("PopularServices.subtitle")}
                    </h1>
                    <h2 className="tp-section-title">
                      {t("PopularServices.title")}
                    </h2>
                  </div>
                </div>
              </div>
              <div className="row">
                <HomeServiceItem
                  icon_name="pot"
                  title={t("PopularServices.serviceItemOne")}
                  subtitle={t("PopularServices.serviceItemOneInfo")}
                />

                <HomeServiceItem
                  icon_name="vacuum-cleaner"
                  title={t("PopularServices.serviceItemTwo")}
                  subtitle={t("PopularServices.serviceItemTwoInfo")}
                />

                <HomeServiceItem
                  icon_name="house-cleaning"
                  title={t("PopularServices.serviceItemThere")}
                  subtitle={t("PopularServices.serviceItemThereInfo")}
                />

                <HomeServiceItem
                  icon_name="desk"
                  title={t("PopularServices.serviceItemFour")}
                  subtitle={t("PopularServices.serviceItemFourInfo")}
                />

                <HomeServiceItem
                  icon_name="cleaning"
                  title={t("PopularServices.serviceItemFive")}
                  subtitle={t("PopularServices.serviceItemFiveInfo")}
                />

                <HomeServiceItem
                  icon_name="window"
                  title={t("PopularServices.serviceItemSix")}
                  subtitle={t("PopularServices.serviceItemSixInfo")}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServiceArea;
